export function filterUserInfo(settings, user) {
    const validFields = {};
    const missingFields = [];
    const requiredMarkers = ['enabled', 'required', 'validated', true];

    for (const [field, requirement] of Object.entries(settings)) {
        const value = user[field];
        const isEmpty = value === null || value === undefined || value === '';

        if (isEmpty) {
            if (requiredMarkers.includes(requirement)) {
                missingFields.push(field);
            }
        } else {
            validFields[field] = String(value);
        }
    }

    return { validFields, missingFields };
}
